import { useNavigate } from "react-router-dom";
import { useUser } from "@clerk/react";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  Settings02Icon,
  Book01Icon,
  UserIcon,
  // PaintBoardIcon, // TODO: uncomment to enable Brand Kit feature
  CreditCardIcon,
  Analytics02Icon,
} from "@hugeicons/core-free-icons";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

interface SettingsSidebarProps {
  projectId?: string;
  activeSection: string;
  onSectionChange: (section: string) => void;
}

export function SettingsSidebar({
  projectId,
  activeSection,
  onSectionChange,
}: SettingsSidebarProps) {
  const navigate = useNavigate();
  const { user } = useUser();

  return (
    <Sidebar variant="inset" collapsible="none" className="w-64">
      <SidebarHeader className="p-2 px-1">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              onClick={() => navigate(projectId ? `/projects/${projectId}` : "/dashboard")}
              className="px-2"
            >
              <HugeiconsIcon icon={ArrowLeft01Icon} className="size-4" />
              <span>Go back</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        {projectId && (
          <SidebarGroup>
            <SidebarGroupLabel>Project</SidebarGroupLabel>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  isActive={activeSection === "project-settings"}
                  onClick={() => onSectionChange("project-settings")}
                >
                  <HugeiconsIcon icon={Settings02Icon} className="size-4" />
                  <span>Project Settings</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  isActive={activeSection === "knowledge"}
                  onClick={() => onSectionChange("knowledge")}
                >
                  <HugeiconsIcon icon={Book01Icon} className="size-4" />
                  <span>Knowledge</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroup>
        )}

        <SidebarGroup>
          <SidebarGroupLabel>Account</SidebarGroupLabel>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                isActive={activeSection === "account"}
                onClick={() => onSectionChange("account")}
              >
                <HugeiconsIcon icon={UserIcon} className="size-4" />
                <span>{user?.fullName ?? "Account"}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
            {/* TODO: uncomment to enable Brand Kit feature
            <SidebarMenuItem>
              <SidebarMenuButton
                isActive={activeSection === "brand-kit"}
                onClick={() => onSectionChange("brand-kit")}
              >
                <HugeiconsIcon icon={PaintBoardIcon} className="size-4" />
                <span>Brand Kit</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
            */}
            <SidebarMenuItem>
              <SidebarMenuButton
                isActive={activeSection === "plans-usage"}
                onClick={() => onSectionChange("plans-usage")}
              >
                <HugeiconsIcon icon={CreditCardIcon} className="size-4" />
                <span>Plans & usage</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButton
                isActive={activeSection === "usage-history"}
                onClick={() => onSectionChange("usage-history")}
              >
                <HugeiconsIcon icon={Analytics02Icon} className="size-4" />
                <span>Usage history</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
